import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';

import ProgressWizard from 'components/field/ProgressWizard';
import Alert from 'components/global/Alert';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalTitle } from 'components/global/styled/Modal.styled';

import useMediaQuery from 'hooks/useMediaQuery';
import useModalRouter from 'hooks/useModalRouter';

import { Breakpoints } from 'utils/const.styles';

import { faCheck, faCreditCard } from '@fortawesome/pro-solid-svg-icons';

import * as S from './AddPaymentMethod.styled';
import CompletedModal from './CompletedModal';
import PaymentModal from './PaymentModal';

const TABS = {
	paymentMethod: { name: 'subscription.payment', icon: faCreditCard },
	completed: { name: 'subscription.completed', icon: faCheck, success: true }
};

const ADD_PAYMENT_TABS = [TABS.paymentMethod, TABS.completed];

const AddPaymentMethodModal = NiceModal.create(({ modalName, cancelDowngradeRequest, customAlertText }) => {
	const { closeModal } = useModalRouter();
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const modal = useModal();

	const [cardLastFour, setCardLastFour] = useState('');
	const [selectedIndex, setSelectedIndex] = useState(0);

	useEffect(() => {
		if (import.meta.env.VITE_PLATFORM === 'desktop' && modal.visible) {
			if (modal.visible) {
				handleCloseModal();
			}
			window?.electronAPI?.openExternalBrowser?.(
				`https://${import.meta.env.VITE_ENVIRONMENT === 'production' ? 'app' : 'staging-api'}.tryoto.com/manage-subscription&oto-token=${localStorage.getItem('ACCESS_TOKEN')}`
			);
		}
	}, [modal.visible]);

	const handleCloseModal = () => {
		if (modalName) {
			closeModal();
		} else {
			modal.resolve();
			modal.remove();
		}
	};

	const renderTab = (index) => {
		const tab = ADD_PAYMENT_TABS[index];
		switch (tab.name) {
			case TABS.paymentMethod.name:
				return (
					<PaymentModal setCardLastFour={setCardLastFour} closeModal={handleCloseModal} nextStep={nextStep} />
				);
			case TABS.completed.name:
				return (
					<CompletedModal
						closeModal={handleCloseModal}
						cancelDowngradeRequest={cancelDowngradeRequest}
						cardLastFour={cardLastFour}
					/>
				);
			default:
				return null;
		}
	};

	const nextStep = () => {
		if (selectedIndex + 1 < ADD_PAYMENT_TABS.length) setSelectedIndex(selectedIndex + 1);
	};

	return (
		<Modal name={modalName} maxWidth="x-large" fullwidth className="modal-subscriptionAddPayment">
			<ModalTitle>
				<Typography variant="p1">addPaymentMethod</Typography>
			</ModalTitle>

			<ProgressWizard
				className={isMobile ? 'mt-4' : ''}
				stages={ADD_PAYMENT_TABS}
				index={selectedIndex}
				setIndex={setSelectedIndex}
				clickable={false}
				gutterBottom
			/>

			{customAlertText && <Alert content={customAlertText} showIcon className="mt-3" />}

			<S.FormContainer>{renderTab(selectedIndex)}</S.FormContainer>
		</Modal>
	);
});

export default AddPaymentMethodModal;
